/**
 * DOM utility helpers used across theme modules.
 */

/** querySelectorAll shortcut that returns a real Array. */
export function qsa(selector: string, root?: Element | Document): Element[] {
  return Array.from((root ?? document).querySelectorAll(selector));
}

/** Delegate event listener (replaces jQuery's $(document).on). */
export function delegate(
  eventType: string,
  selector: string,
  handler: (this: Element, e: Event) => void,
): void {
  document.addEventListener(eventType, (e: Event) => {
    const target = (e.target as Element | null)?.closest(selector);
    if (target && document.contains(target)) {
      handler.call(target, e);
    }
  });
}

/** Inject CSS animation helpers (fade-in / fade-out). */
export function injectAnimationStyles(): void {
  const style = document.createElement("style");
  style.textContent = `
    .js-fade-in {
      opacity: 0.7;
      transition: opacity 0.4s ease;
    }
    .js-fade-out {
      opacity: 0;
      transition: opacity 0.4s ease;
      pointer-events: none;
    }
  `;
  document.head.appendChild(style);
}
